import React, { SVGProps } from "react";
export default function SupAlert2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="7.6" stroke="currentColor" strokeWidth="0.8" />
      <path d="M12.498 10.404V8.14801H11.514V10.404L11.682 13.56H12.318L12.498 10.404Z" fill="currentColor" />
      <path d="M12.75 15.852V14.46H11.25V15.852H12.75Z" fill="currentColor" />
    </svg>
  );
}
